import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Accept")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Decline")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Go To Pulse")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" View Sync ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" View Pulse ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" View Objective ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" View Goal ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" View Social Connect ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" View Team Pulse ")
const _hoisted_11 = {
  key: 0,
  class: "main-notification-panel__empty-notifications"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAvatar = _resolveComponent("AppAvatar")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_NotificationItem = _resolveComponent("NotificationItem")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "main-notification-panel" }, _ctx.$attrs), [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
      return (_openBlock(), _createBlock(_component_NotificationItem, {
        createdAt: notification.createdAt,
        key: notification.id,
        class: _normalizeClass({ seen: notification.status !== _ctx.NotificationStatus.New })
      }, {
        title: _withCtx(() => [
          _createElementVNode("p", {
            innerHTML: notification.title
          }, null, 8, _hoisted_1)
        ]),
        timestamp: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.timeDiffCalc(notification.createdAt)), 1)
        ]),
        actions: _withCtx(() => [
          (_ctx.isActionableTeamInvite(notification))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 0,
                size: "small",
                onClick: _withModifiers(($event: any) => (_ctx.acceptInvite(notification)), ["prevent"]),
                loading: _ctx.acceptingInviteId === notification.id
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 2
              }, 1032, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.isActionableTeamInvite(notification))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 1,
                size: "small",
                theme: "secondary",
                onClick: _withModifiers(($event: any) => (_ctx.declineInvite(notification)), ["prevent"]),
                loading: _ctx.decliningInviteId === notification.id
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 2
              }, 1032, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.isCheckInReminder(notification))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 2,
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/pulse' }),_ctx.$emit('close-navigation-panel')))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isDailySyncUpdated(notification))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 3,
                size: "small",
                onClick: ($event: any) => (_ctx.$router.push({ path: '/', query: { teamId: notification.context.dailySync.teamId, date: notification.context.dailySync.date, userId: notification.context.dailySync.userId } }),
          _ctx.$emit('close-navigation-panel'))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isCheckInItemUpdated(notification))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 4,
                size: "small",
                onClick: ($event: any) => (_ctx.$router.push({ path: '/pulse', query: { teamId: notification.context.checkInItem.teamId, cycle: notification.context.checkInItem.checkInId, selected: notification.context.checkInItem.id } }),
          _ctx.$emit('close-navigation-panel'))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isObjectiveUpdated(notification))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 5,
                size: "small",
                onClick: ($event: any) => (_ctx.$router.push({ path: '/goals', query: { teamId: notification.context.objective.teamId, objectiveId: notification.context.objective.id } }),
          _ctx.$emit('close-navigation-panel'))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isGoalUpdated(notification))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 6,
                size: "small",
                onClick: ($event: any) => (_ctx.$router.push({ path: '/goals', query: { teamId: notification.context.goal.teamId, objectiveId: notification.context.goal.objectiveId, goalId: notification.context.goal.id } }),
          _ctx.$emit('close-navigation-panel'))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isSocialConnectUpdated(notification))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 7,
                size: "small",
                onClick: ($event: any) => (_ctx.$router.push({ path: '/', query: { teamId: notification.context.itemId.teamId, date: notification.context.itemId.date, socialConnect: true } }),
          _ctx.$emit('close-navigation-panel'))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isDreInsightsUpdated(notification))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 8,
                size: "small",
                onClick: ($event: any) => (_ctx.$router.push({ path: '/', query: { teamId: notification.context.itemId.teamId, dreInsights: true } }),
          _ctx.$emit('close-navigation-panel'))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_ctx.getTeamMember(notification.senderId))
            ? (_openBlock(), _createBlock(_component_AppAvatar, {
                key: 0,
                user: _ctx.getTeamMember(notification.senderId),
                size: "normal"
              }, null, 8, ["user"]))
            : (notification.profile)
              ? (_openBlock(), _createBlock(_component_AppAvatar, {
                  key: 1,
                  user: notification.profile,
                  size: "normal"
                }, null, 8, ["user"]))
              : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["createdAt", "class"]))
    }), 128)),
    (!_ctx.notifications.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.emptyNotificationsPanel), 1))
      : _createCommentVNode("", true)
  ], 16))
}